<template>
  <Header/>
  <Table/>
</template>

<script>
import Header from './header'
import Table from './table'

export default {
  name: 'tabIngresos',
  components: {
    Header,
    Table
  }
}
</script>

<style scoped>

</style>
